import { render } from "./DadminLogin.vue?vue&type=template&id=6e8f58fe&scoped=true"
import script from "./DadminLogin.vue?vue&type=script&lang=js"
export * from "./DadminLogin.vue?vue&type=script&lang=js"

import "./DadminLogin.vue?vue&type=style&index=0&id=6e8f58fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8f58fe"]])

export default __exports__